import Vue from "vue";
// register globally
import Sticky from 'vue-sticky-directive';
Vue.use(Sticky);
export default Vue.extend({
    name: 'ReferenceBackBtn'
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/*Work/reference-back-btn/ReferenceBackBtn.ts
// module id = null
// module chunks = 